/**
 * MEDICLOUD REST API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { OrderContentType } from './orderContentType';
import { AssessmentResult } from './assessmentResult';
import { AssessmentTypeEnum } from './assessmentTypeEnum';


export interface OrderApiModel { 
    id: number;
    tenantEmployerId: number;
    number: string;
    type: AssessmentTypeEnum;
    employeeId: number;
    employeeTitleBeforeName: string;
    employeeName: string;
    employeeSurname: string;
    employeeTitleAfterName: string;
    providerId?: number | null;
    providerName?: string | null;
    createDate: string;
    issueDate: string;
    orderResultStatus: AssessmentResult;
    orderContentType: OrderContentType;
}
export namespace OrderApiModel {
}


